import { BaseEvent } from '@packages/shared/core/analytics/events/BaseEvent';
import { BaseEventHandler } from '@packages/shared/core/analytics/events/BaseEventHandler';

export class SimpleRegistrationMainPageExpertsOpenedEvent extends BaseEvent {}

export class SimpleRegistrationMainPageExpertsOpenedEventHandler extends BaseEventHandler {
  shouldTrack(event: BaseEvent): boolean {
    return event instanceof SimpleRegistrationMainPageExpertsOpenedEvent;
  }

  async track() {
    return this.amplitudeService.logEvent('registration_experts_start_screen_open');
  }
}
